function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'blue': 'rgb(0, 103, 185)','bleu': 'rgb(0, 103, 185)','charcoal': 'rgb(107, 107, 107)','gris-charbon': 'rgb(107, 107, 107)','cream': 'rgb(228, 213, 196)','creme': 'rgb(228, 213, 196)','dark-blue': 'rgb(0, 0, 139)','bleu-fonce': 'rgb(0, 0, 139)','gray': 'rgb(162, 170, 173)','gris': 'rgb(162, 170, 173)','green': 'rgb(0, 64, 53)','vert': 'rgb(0, 64, 53)','ivory': 'rgb(248, 242, 233)','ivoire': 'rgb(248, 242, 233)','light-blue': 'rgb(48, 127, 226)','bleu-pale': 'rgb(48, 127, 226)','maroon': 'rgb(134, 38, 51)','bourgogne': 'rgb(134, 38, 51)','mint': 'rgb(181, 227, 216)','menthe': 'rgb(181, 227, 216)','natural': 'rgb(230, 216, 194)','beige': 'rgb(230, 216, 194)','natural': 'rgb(222, 209, 182)','beige': 'rgb(222, 209, 182)','navy': 'rgb(4, 30, 66)','bleu-marine': 'rgb(4, 30, 66)','oatmeal-heather': 'rgb(217, 215, 212)','beige-chine': 'rgb(217, 215, 212)','orange': 'rgb(237, 139, 0)','pink': 'rgb(255, 105, 175)','rose': 'rgb(255, 105, 175)','purple': 'rgb(92, 55, 162)','violet': 'rgb(92, 55, 162)','red': 'rgb(166, 25, 46)','rouge': 'rgb(166, 25, 46)','sand': 'rgb(215, 207, 192)','sable': 'rgb(215, 207, 192)','stone': 'rgb(220, 211, 207)','gris-pierre': 'rgb(220, 211, 207)','teal': 'rgb(0, 186, 179)','sarcelle': 'rgb(0, 186, 179)','vintage-black': 'rgb(56, 56, 56)','noir-retro': 'rgb(56, 56, 56)','yellow': 'rgb(255, 209, 0)','jaune': 'rgb(255, 209, 0)',};

    this.images = {'style-1': 'url("//ca.shop.thepwhl.com/cdn/shop/files/PomPomStyle_1_68x.png?v=8979928674867380924")','style-2': 'url("//ca.shop.thepwhl.com/cdn/shop/files/PomPomStyle_2_68x.png?v=10638948362844463262")','style-3': 'url("//ca.shop.thepwhl.com/cdn/shop/files/PomPomStyle_3_68x.png?v=16168229526300955680")','style-4': 'url("//ca.shop.thepwhl.com/cdn/shop/files/PomPomStyle_4_68x.png?v=4302368902724400219")','rainbow': 'url("//ca.shop.thepwhl.com/cdn/shop/files/rainbow_68x.png?v=1589576556096543446")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
